export default "/images/cross-gray.png?382b3616a33bb9b80144719681094b9d";